import data from './lists/WAW2_After_words_022223.json';

interface WordChoiceV2 {
  word: string;
  correction: string;
}
export default function words(): Array<WordChoiceV2> {
  return data;
}
